import { EventManager } from "./EventManager";
export const isBrowser = () => {
    return typeof window !== "undefined";
};
export const getBrowserInfo = () => {
    if (!isBrowser())
        return { name: "", version: "" };
    const userAgent = navigator.userAgent;
    // Simple browser detection
    let browserName = "Unknown";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
        browserName = "Chrome";
    }
    else if (userAgent.includes("Firefox")) {
        browserName = "Firefox";
    }
    else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        browserName = "Safari";
    }
    else if (userAgent.includes("Edg")) {
        browserName = "Edge";
    }
    return { name: browserName, version: "" };
};
export const getOSInfo = () => {
    if (!isBrowser())
        return { name: "", version: "" };
    const userAgent = navigator.userAgent;
    let osName = "Unknown";
    let osVersion = "";
    if (userAgent.includes("Windows")) {
        osName = "Windows";
    }
    else if (userAgent.includes("Mac OS")) {
        osName = "macOS";
    }
    else if (userAgent.includes("Linux")) {
        osName = "Linux";
    }
    else if (userAgent.includes("Android")) {
        osName = "Android";
    }
    else if (userAgent.includes("iOS")) {
        osName = "iOS";
    }
    return { name: osName, version: osVersion };
};
export const getDeviceInfo = () => {
    if (!isBrowser())
        return { vendor: "", model: "", type: "" };
    const userAgent = navigator.userAgent.toLowerCase();
    // Simple device detection
    let vendor = "";
    let model = "";
    let type = "";
    if (userAgent.includes("iphone")) {
        vendor = "Apple";
        model = "iPhone";
        type = "mobile";
    }
    else if (userAgent.includes("ipad")) {
        vendor = "Apple";
        model = "iPad";
        type = "tablet";
    }
    else if (userAgent.includes("android")) {
        vendor = "Android";
        type = "mobile";
    }
    return { vendor, model, type };
};
export const getDeviceType = () => {
    if (!isBrowser())
        return "Laptop/Desktop";
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipod|blackberry|iemobile|opera mini/.test(userAgent);
    const isTablet = /ipad|tablet|playbook|silk/.test(userAgent);
    if (isTablet)
        return "Tablet";
    if (isMobile)
        return "Mobile";
    return "Laptop/Desktop";
};
export const getDeviceTypeByScreenSize = () => {
    if (!isBrowser())
        return "Laptop/Desktop";
    const width = window.innerWidth;
    if (width <= 768) {
        return "Mobile";
    }
    else if (width > 768 && width <= 1024) {
        return "Tablet";
    }
    else {
        return "Laptop/Desktop";
    }
};
export const getWorkflowType = () => {
    if (!isBrowser())
        return "IFM";
    const params = new URLSearchParams(window.location.search);
    const workflow = params.get("workflow");
    const osInfo = getOSInfo();
    return (osInfo.name.toLowerCase() === "android" && workflow !== "og") ||
        workflow === "ng"
        ? "IWR"
        : "IFM";
};
export const sendEvent = (event, eventProperties = {}) => {
    const eventManager = new EventManager({ name: event, eventProperties });
    eventManager.sendEvent();
};
